/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Map constants
 */

export const MAIN_MAP_ID = 'NZR_MAIN_MAP_ID'
export const NAVBAR_MOBILE_LIST = 'list'
